import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class MetaRoleResource implements MutableValue {
  public isNew = true;
  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fMetaRole: string,
    private fResource: string
  ) {
    [fId, fMetaRole, fResource].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get metaRole() {
    return this.fMetaRole;
  }

  get resource() {
    return this.fResource;
  }
}
